import { Outlet } from 'react-router'

const StockSupplyInventoryLayout = () => {
  return (
    <Outlet />
  )
}

export default StockSupplyInventoryLayout
